import { useEffect, useState } from 'react';

type DelayProps = {
    children: JSX.Element;
    waitBeforeShow?: number;
};

const Delayed = (props: DelayProps): JSX.Element => {

    const [isShown, setIsShown] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsShown(true);
        }, props.waitBeforeShow);
        return () => clearTimeout(timer);
    }, [props.waitBeforeShow]);

    return isShown ? props.children : null;
};

export default Delayed;